/**
 * 데스크탑 웹 환경에서 콘텐츠 영역 최대 폭(px).
 *
 * 웹 데스크탑에서 모바일 뷰 가운데 정렬 cap으로 사용.
 * `apps/ably-web/src/App.tsx`의 `ADSContext.contentWidth` 산출 및
 * `packages/search/`의 헤더 가운데 정렬에서 공통으로 참조.
 */
export const DESKTOP_MAX_WIDTH = 600;
